import React, { useEffect } from "react";
import { useStore } from "store/storeUtils.js";
import { useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import Client from "gqlclient/Client";
import { logout } from "./auth";
import { logger } from "@tecma/logs-fe";
import { observer } from "mobx-react";
import Cookies from "js-cookie";

const JwtChecker = observer(() => {
  const store = useStore();
  const history = useHistory();

  const [logoutMutation] = useMutation(Client.LOGOUT);
  const [loadUserInfo, userInfo] = useLazyQuery(
    Client.GET_USER_INFO,
    Client.GET_USER_INFO_DEFAULT_OPTIONS(store.projectId),
  );

  const skipCondition = () => {
    return ["login", "changePassword", "forgotPassword", "resetPassword"].some((route) =>
      window.location.pathname.includes(route),
    );
  };

  useEffect(() => {
    if (userInfo && !userInfo.loading && userInfo.called) {
      if (userInfo.data?.getUserByJWT) {
        if (Cookies.get("jwt")) {
          store.setLoggedUser(userInfo.data.getUserByJWT);
        } else {
          logout(history, store);
        }
      }
      if (userInfo.error || userInfo.data?.errors?.length) logout(history, store);
      store.setCheckingJwt(false);
    }
    // eslint-disable-next-line
  }, [userInfo]);

  useEffect(() => {
    if (store.forcingLogout) {
      logoutMutation()
        .catch((err) => logger.error(err))
        .finally(() => {
          logout(history, store);
          store.setForcingLogout(false);
        });
    }
    // eslint-disable-next-line
  }, [store.forcingLogout]);

  function handleVisibilityChange() {
    if (!document.hidden && !skipCondition()) {
      if (!Cookies.get("jwt")) {
        logout(history, store);
        return;
      }
      store.setCheckingJwt(true);
      loadUserInfo();
    }
  }

  useEffect(() => {
    window.addEventListener("visibilitychange", handleVisibilityChange);
    return () => window.removeEventListener("visibilitychange", handleVisibilityChange);
    // eslint-disable-next-line
  }, []);

  return <></>;
});

export default JwtChecker;
